import React, {FC} from "react";

export const InputContainer: FC<any> = ({...props}) => {
  return <div className={"container ebd-container-bg mb-4"}>{props.children}</div>;
};

export default InputContainer;
